import { toast } from "sonner";
import request from "../../../../helpers/request";
import { IDeleteConfigPtMonMedidor } from "./types";

export const deleteConfigPtMonMedidor = async ({
  adrModulo,
  idCentral,
  idEntrada,
}: IDeleteConfigPtMonMedidor) => {
  try {
    const url = `${process.env.REACT_APP_API}/MonMedidor/DeleteConfig/${idCentral}/${adrModulo}/${idEntrada}`;
    const result = await request({ url, method: "delete" });

    if (result.status !== 200) {
      toast.error("Houve um erro ao excluir configuração!");
      return {
        status: result.status,
        data: result.data,
      };
    }

    if (result.status === 200) {
      toast.success("Configuração excluída com sucesso!");
      return result.data;
    }
  } catch (error: any) {
    const apiError = error.response?.data;

    if (process.env.NODE_ENV === "development") {
      console.error("Datalhes do Erro:", apiError);
    }

    let mensagemExibicao = "Erro ao processar a requisição.";

    if (apiError?.errors) {
      const detalhes = Object.values(apiError.errors).flat().join(" | ");
      mensagemExibicao = detalhes;
    } else if (apiError?.title) {
      mensagemExibicao = apiError.title;
    }

    toast.error(mensagemExibicao, {
      description: "Verifique os campos e tente novamente.",
    });
  }
};
